import React from 'react';
import './QuantitySelector.css';

function QuantitySelector({quantity, minQuantity, maxQuantity, onChange}) {
    const handleDecreaseButtonClick = () => {
        if (quantity <= minQuantity) return null;
        handleChange(quantity - 1);
    };

    const handleIncreaseButtonClick = () => {
        if (quantity >= maxQuantity) return null;
        handleChange(quantity + 1);
    };

    const handleChange = (newQuantity) => {
        if (onChange) onChange(newQuantity);
    };

    const getQuantity = () => {
        if (quantity < 10) return `0${quantity}`;
        else return quantity;
    };

    return (
        <div className='quantity-selector'>
            <div className='quantity-selector_button' onClick={handleDecreaseButtonClick}>
                <div className='quantity-selector_button-label'>-</div>
            </div>
            <div className='quantity-selector_value'>{getQuantity()}</div>
            <div className='quantity-selector_button' onClick={handleIncreaseButtonClick}>
                <div className='quantity-selector_button-label'>+</div>
            </div>
        </div>
    );
}

export default QuantitySelector;